import React, { createContext, useContext, useEffect, useState } from 'react';

interface ZoomContextType {
  zoom: number;
  setZoom: (zoom: number) => void;
}

const ZoomContext = createContext<ZoomContextType | undefined>(undefined);

const ZOOM_STORAGE_KEY = 'locanest:ui:zoom';
const ZOOM_PRESETS = [0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3];

export function ZoomProvider({ children }: { children: React.ReactNode }) {
  const [zoom, setZoomState] = useState<number>(() => {
    const saved = localStorage.getItem(ZOOM_STORAGE_KEY);
    return saved ? parseFloat(saved) : 0.8;
  });

  const setZoom = (newZoom: number) => {
    const clampedZoom = Math.max(0.5, Math.min(1.5, newZoom));
    setZoomState(clampedZoom);
    localStorage.setItem(ZOOM_STORAGE_KEY, clampedZoom.toString());
  };

  return (
    <ZoomContext.Provider value={{ zoom, setZoom }}>
      {children}
    </ZoomContext.Provider>
  );
}

export function useZoom() {
  const context = useContext(ZoomContext);
  if (context === undefined) {
    throw new Error('useZoom must be used within a ZoomProvider');
  }
  return context;
}

export { ZOOM_PRESETS };
